module.exports = __webpack_public_path__ + "img/AY.51cdfc04.jpg";